import {Controller} from '@stimulus/core'
import HSHeader from '../../../../../vendor/front/vendor/hs-header/src/js/hs-header'

// data-controller='hs--header'
// data-hs-circles-options='{}' https://htmlstream.com/preview/front-v3.2.2/documentation/headers.html#methods

export default class extends Controller {
  connect() {
    new HSHeader($(this.element)).init()
  }
}
